import {MediaAccess} from './media-access';

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CANCELLED = 'CANCELLED',
  BLOCKED = 'BLOCKED',
  SUSPENDED = 'SUSPENDED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  REJECTED = 'REJECTED'
}

export class Account {

  id: number;
  accountNumber: string;
  clabe: string;
  status: AccountStatus;
  mediaAccess: MediaAccess[];

  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
      this.status = typeof object.status == 'number' ? object.status : AccountStatus[object.status as string];
      if (object.mediaAccess != null) {
        this.mediaAccess = object.mediaAccess.map((item) => new MediaAccess(item));
      } else {
        this.mediaAccess = [];
      }
    }
  }
}
